import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",staticClass:"sig-canvas",on:{"pointerdown":_vm.down,"pointermove":_vm.move,"pointerup":_vm.up,"pointerleave":_vm.up}}),_c('div',{staticClass:"text-right"},[_c(VBtn,{attrs:{"small":"","text":""},on:{"click":_vm.clear}},[_vm._v("ล้าง")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }